export default __webpack_public_path__ + "static/media/frequencyIcon.4d356fbb.svg";